import { useSelector } from 'react-redux';
import { Link } from 'react-router';

import appSelectors from '@/redux/app/appSelectors';

import RouteNames from '@/router/routes';

import s from './linkPads.module.css';

function LinkPads() {
  const i18n = useSelector(appSelectors.translation);

  return (
    <div className={s.sidebar}>
      <ul className={s.links_list}>
        <li>
          <Link to={`/${RouteNames.VPS_FREE}`} className={s.vps_free}>
            {i18n.получить_бесплатный_vps}
          </Link>
        </li>
        <li>
          <Link to={`/${RouteNames.VPS_PAID}`} className={s.vps_paid}>
            {i18n.арендовать_vps_сервер}
          </Link>
        </li>
        <li>
          <Link to={`/${RouteNames.MONITORING}`} className={s.monitoring}>
            {i18n.оформить_подписку_на_мониторинг}
          </Link>
        </li>
        <li>
          <Link to={`/${RouteNames.REBATE}`} className={s.rebate}>
            {i18n.подключить_счет_к_рибейт_сервису}
          </Link>
        </li>
        <li>
          <Link to={`/${RouteNames.ROBOT}`} className={s.robot}>
            {i18n.разработка_советника_на_заказ}
          </Link>
        </li>
        <li>
          <Link to={`/${RouteNames.PARTNER_CLASSIC}`} className={s.partner}>
            {i18n.партнерская_программа}
          </Link>
        </li>
      </ul>
    </div>
  );
}

export default LinkPads;
